import { createTheme as o } from "./ghl-ui.es855.js";
import i from "./ghl-ui.es1157.js";
import t from "./ghl-ui.es1130.js";
const m = o({
  name: "Ellipsis",
  common: i,
  peers: {
    Tooltip: t
  }
}), l = m;
export {
  l as default
};
